<template lang="html">
  <div class="no-container">
    <div class="img-group">
      <img :src="$store.state.static_img_url + 'pic/404bg.png'">
      <div>
        <img :src="$store.state.static_img_url + 'pic/ico_404.png'">
        <p>抱歉！您访问的页面不存在</p>
        <router-link :to="{ name: 'NewsList'}">返回首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.img-group
  position: relative
  >img
    width: 100%
    height: 700px
  >div
    position: absolute
    top: 34%
    left: 50%
    transform: translateX(-50%)
    text-align: center
    >img
      width: 218px
      height: 110px
    p
      font-size: 22px
      color: #666666
      margin-top: 60px
    a
      margin: 30px auto 0
      display: block
      background: rgba(250, 122, 80, 1)
      width: 150px
      height: 44px
      border-radius:22px
      box-shadow:0px 8px 16px 0px rgba(17,93,170,0.15)
      color: #FFFFFF
      font-size: 16px
      line-height: 44px
      &:hover
        background: #1572e7
</style>
